var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifierPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1579 10.5789C18.1579 14.7647 14.7647 18.1579 10.5789 18.1579C6.39321 18.1579 3 14.7647 3 10.5789C3 6.39321 6.39321 3 10.5789 3C14.7647 3 18.1579 6.39321 18.1579 10.5789ZM14.3684 11.5311H11.5311V14.3684H9.62681V11.5311H6.78947V9.62681H9.62681V6.78947H11.5311V9.62681H14.3684V11.5311ZM18.5909 17.2512C18.221 16.8812 17.6211 16.8812 17.2512 17.2512C16.8812 17.6211 16.8812 18.221 17.2512 18.5909L19.3827 20.7225C19.7527 21.0925 20.3526 21.0925 20.7225 20.7225C21.0925 20.3526 21.0925 19.7527 20.7225 19.3827L18.5909 17.2512Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierPlus);
export default __webpack_public_path__ + "static/media/MagnifierPlus.118e64e8.svg";
export { ForwardRef as ReactComponent };